import { render, staticRenderFns } from "./EzButtonDropdown.vue?vue&type=template&id=0216bb5c&scoped=true&"
import script from "./EzButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./EzButtonDropdown.vue?vue&type=script&lang=js&"
import style0 from "./EzButtonDropdown.vue?vue&type=style&index=0&id=0216bb5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216bb5c",
  null
  
)

export default component.exports